import React, { useState, useEffect } from 'react';
import {
    Box,
    Container,
    Typography,
    Card,
    CardContent,
    TextField,
    Button,
    Grid,
    MenuItem,
    Alert,
} from '@mui/material';
import { Save, ArrowBack } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../config';

const DraftEditor = () => {
    const navigate = useNavigate();
    const { id } = useParams(); // For edit mode
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        title: '',
        platform: 'whatsapp', // Default
        content: { text: '' },
        metadata: {}
    });

    useEffect(() => {
        if (id) {
            fetchDraft();
        }
    }, [id]);

    const fetchDraft = async () => {
        try {
            const token = localStorage.getItem('token');
            const { data } = await axios.get(`${API_BASE_URL}/api/drafts/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setFormData({
                title: data.title,
                platform: data.platform,
                content: data.content,
                metadata: data.metadata
            });
        } catch (error) {
            console.error('Error fetching draft:', error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'text') {
            setFormData({ ...formData, content: { ...formData.content, text: value } });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleSave = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const dataToSend = {
                title: formData.title,
                platform: formData.platform,
                content: formData.content,
            };

            if (id) {
                await axios.put(`${API_BASE_URL}/api/drafts/${id}`, dataToSend, {
                    headers: { Authorization: `Bearer ${token}` }
                });
            } else {
                await axios.post(`${API_BASE_URL}/api/drafts`, dataToSend, {
                    headers: { Authorization: `Bearer ${token}` }
                });
            }
            navigate('/drafts');
        } catch (error) {
            console.error('Error saving draft:', error);
            alert('Failed to save draft');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 3, gap: 2 }}>
                <Button startIcon={<ArrowBack />} onClick={() => navigate('/drafts')}>
                    رجوع
                </Button>
                <Typography variant="h4" fontWeight="bold">
                    {id ? 'تعديل المسودة' : 'مسودة جديدة'}
                </Typography>
            </Box>

            <Card>
                <CardContent>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label="عنوان المسودة"
                                name="title"
                                value={formData.title}
                                onChange={handleChange}
                                placeholder="مثال: حملة رمضان 2024"
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <TextField
                                fullWidth
                                select
                                label="المنصة"
                                name="platform"
                                value={formData.platform}
                                onChange={handleChange}
                            >
                                <MenuItem value="whatsapp">WhatsApp</MenuItem>
                                <MenuItem value="telegram">Telegram</MenuItem>
                                <MenuItem value="facebook">Facebook</MenuItem>
                                <MenuItem value="instagram">Instagram</MenuItem>
                            </TextField>
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                multiline
                                rows={6}
                                label="محتوى المنشور"
                                name="text"
                                value={formData.content.text}
                                onChange={handleChange}
                                placeholder="اكتب محتوى المنشور هنا..."
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Button
                                variant="contained"
                                startIcon={<Save />}
                                onClick={handleSave}
                                disabled={loading}
                                size="large"
                            >
                                {loading ? 'جاري الحفظ...' : 'حفظ المسودة'}
                            </Button>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Container>
    );
};

export default DraftEditor;
